import type { CSSProperties } from 'react';
import type { TaskTypeStyleType } from '@econtractor/types';
import SolarIcon from 'components/icons/SolarIcon';

interface TaskTypeChipProps {
    name?: string | null;
    icon?: string | null;
    colors?: TaskTypeStyleType | null;
    /** Розмір шрифту чіпа (напр. '0.7rem'); за замовчуванням — зі стилів */
    fontSize?: string | number;
}

const TaskTypeChip = ({ name, icon, colors, fontSize }: TaskTypeChipProps) => {
    if (!name) return <span className="text-muted">—</span>;
    const style: CSSProperties = {
        backgroundColor: colors?.backgroundColor || '#E5E7EB',
        color: colors?.textColor || '#4B5563',
    };
    if (fontSize != null) style.fontSize = fontSize;
    return (
        <span className="task-type-chip d-inline-flex align-items-center" style={style}>
            {icon ? <SolarIcon name={icon} style={fontSize != null ? { fontSize: '1em' } : undefined} /> : null}
            <span>{name}</span>
        </span>
    );
};

export default TaskTypeChip;
